import { Box } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLocale } from "../../../hooks/UseLocale";
import { MainTitle, Subtitle } from "./PageTitle.styles";

interface PageTitleProps {
  title: string;
  breadcrumbs?: {
    title: string;
    link: string;
  }[];
}

const PageTitle: FC<PageTitleProps> = ({ breadcrumbs, title }) => {
  const { t } = useTranslation();
  const locale = useLocale();

  return (
    <>
      <MainTitle>{title}</MainTitle>
      <Subtitle>
        {
          breadcrumbs
            ?
            breadcrumbs.map((item) =>
              item.link ? (
                <Link key={item.title} to={`/${locale}/${item.link}`}>
                  {"> "}
                  {t(item.title)}
                </Link>
              ) : (
                <span key={item.title}>{t(item.title)}</span>
              )
            )
            :
            <Box sx={{ height: "36px" }}></Box>
        }
      </Subtitle>
    </>
  );
};

export default PageTitle;
